import { configureStore } from '@reduxjs/toolkit';
import authReducer from './auth/authSlice';
import globalReducer from './global/globalSlice';
import featureFlagReducer from './featureFlag/featureFlagSlice';

export const store = configureStore({
    reducer: {
        auth: authReducer,
        global: globalReducer,
        featureFlag: featureFlagReducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware({ serializableCheck: false }),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
